import React, { Component } from "react";
import Media from 'react-media';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import classes from "./Passengers.scss";
import Pax from '../../components/Pax/Pax';
import maleTravellerImage from './img/adult-male.svg';
import femaleTravellerImage from './img/adult-female.svg';
import maleChildTravellerImage from './img/kid-male.svg';
import femaleChildTravellerImage from './img/kid-female.svg';
import infantImage from './img/infant.svg';
import AnimakitExpander from "animakit-expander";

import HeadingH2 from '../../components/UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../components/UI/Headings/HeadingH3/HeadingH3';
import HeadingH4 from '../../components/UI/Headings/HeadingH4/HeadingH4';

import StackedTuple from '../../components/Flight/TupleStacked/TupleStacked';
import StackedTupleMobile from '../../components/Flight/TupleStackedMobile/TupleStackedMobile';
import ReviewHotelTuple from '../../components/Hotel/HotelTupleStacked/HotelTupleStacked';
import DropdownMenu from '../../components/UI/DropdownMenu/DropdownMenu';
import DropdownMenuItem from '../../components/UI/DropdownMenu/DropdownMenuItem/DropdownMenuItem';
import { resetSearch, editPax, deletePax, togglePax, toggleHotelPax, closeDropDown, userImageUpload } from '../../store/actions/index';

import imageUploadIcon from '../../assets/images/image-upload.svg';

import DetailForm from '../../components/Addons/DetailForm/DetailForm';

import AddonsWrapper from '../../components/UI/Wrappers/AddonsWrapper/AddonsWrapper';

class Passengers extends Component {

  state = {
    isVisible: true
  }

  onCloseHandler = () => {
    this.setState(prevState => {
      return { isVisible: !prevState.isVisible }
    })
  }

  imageChangeHandler = (e, id) => {
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.props.onUserImageUpload(file, reader.result, id);
    }

    reader.readAsDataURL(file)
  }
  

  render() {
    let passengerList = null;

    const passengers = this.props.lob === "hotel" ? this.props.guests : this.props.passengers;
    passengerList = passengers.map((passenger, index) => {
        let userImage = this.props.userImages.filter(image => image.userId === index);
        const paxDetails = this.props.lob === "hotel" ? passenger.guestDetails[0] : passenger.travellerDetails;
        const title = this.props.lob === "hotel" ? passenger.guestDetails[0].salutation : passenger.travellerDetails.title;
        return (
            <li onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if(this.props.lob === "hotel") {
                this.props.onToggleHotelPax(passenger.paxID);
              } else {
                console.log("inside flights");
                this.props.onTogglePax(passenger.paxID);
              }
            }} className={classes.Item} key={index}>
              <div className={`${classes.ItemHeader} u-flex justify-content-between align-items-center pl-3 pr-3`}>
                <div className={classes.ItemSelect}>
                  {passenger.isSelected ? <div className={classes.ItemSelectActive}></div> : null}
                </div>
                <div className={classes.ItemMenu}>
                  <DropdownMenu index = {index}>
                    <DropdownMenuItem onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              if(this.props.lob === "hotel") {
                                console.log("In Edit Pax")
                              } else {
                                this.props.onEditPax(passenger.paxID);
                              }
                              this.props.onCloseDropDown();
                          }}>Edit</DropdownMenuItem>
                          <DropdownMenuItem onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.props.onDeletePax(passenger.paxID);
                              this.props.onCloseDropDown();
                          }}>Delete</DropdownMenuItem>
                  </DropdownMenu>
                </div>
              </div>
                <div className={`${classes.ItemImage} u-size90x90 mb-3 u-relative`}>
                { userImage.length === 0 ? <div className={classes.ItemImageOverlay}>
                  <label htmlFor='uniqueid' className={`u-block u-cursorPointer u-relative`}>
                    <img src={imageUploadIcon} alt='Upload Icon'/>
                    <input
                    type="file" 
                    id='uniqueid'
                    className={classes.ImageInput}
                    onInput={(e)=>this.imageChangeHandler(e, index)}
                    onClick={(e) => {
                      e.stopPropagation(e, index)
                    }}
                   />
                  </label>
                  </div> : null }
                    {
                      userImage.length === 0 ? <img className={`u-width100Percent u-height100Percent u-block`} src={
                        title === 'Mr' && paxDetails.passengerClass === 'ADT' 
                          ? maleTravellerImage : 
                            title === 'Ms' && paxDetails.passengerClass === 'ADT' ? 
                              femaleTravellerImage : 
                                title === 'Mrs' && paxDetails.passengerClass === 'ADT' ?
                                  femaleTravellerImage :
                                    title === 'Miss' && paxDetails.passengerClass === 'CHD' ? 
                                      femaleChildTravellerImage :
                                        title === 'Master' && paxDetails.passengerClass === 'CHD' ? 
                                          maleChildTravellerImage :
                                            paxDetails.passengerClass === 'INF' ?
                                              infantImage : null } alt="Child" /> : <img src={userImage[0].imagePreviewUrl} alt='User Custom'/>
                    }
                </div>
              <div className="u-textAlignCenter">
                <HeadingH4 size={13} weight="Regular" color="Dark">{this.props.lob === "hotel" ? paxDetails.salutation : paxDetails.title} {paxDetails.firstName} {paxDetails.lastName}</HeadingH4>
              </div>
            </li>
        );
    });

    let paxType = null;
    let paxCount = 0;

    if(this.props.lob === "hotel") {
      paxType = 'Adult';
      paxCount = this.props.hotelPaxCounter;
    } else {
      if(this.props.adultCount > 0) {
        paxType = 'Adult';
        paxCount = this.props.adultCount;
      } else if(this.props.childCount > 0) {
        paxType = 'Child';
        paxCount = this.props.childCount;
      } else {
        paxType = 'Infant'
        paxCount = this.props.infantCount;
      }
    }
    const border = '1px solid var(--color-border)';
    return (
      <React.Fragment>
        <div className={`mb-3 phone-pt-0 phone-pb-0 phone-pl-2 phone-pr-2`}>
        <Media query="(max-width: 599px)">
              {matches =>
                matches ? <div className={`${classes.MobileHeader} u-backgroundColorWhite u-flex justify-content-center align-items-center pl-0 pr-0 pt-4 pb-4`}>
                <div className={'mx-auto'}>
                  <HeadingH3 size={16} weight="Medium" color="Dark">Review Flight Details</HeadingH3>
                </div>
              </div> : null
            }
          </Media>
          <Media query="(min-width: 600px)">
            {matches =>
              matches ? this.props.lob === "hotel" ? (
                <ReviewHotelTuple />
              ) : (
                this.props.flightType === "O" ?
                <div style={{boxShadow: '0 1px 2px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                  <StackedTuple type="onward" />
                </div> : 
                <React.Fragment>
                  <div style={{boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                    <StackedTuple tripType="roundTripOnward" type="onward" />
                  </div>
                  <div style={{boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                    <StackedTuple tripType="roundTripReturn" type="return" />
                  </div>
                </React.Fragment>
              ) : (
                this.props.flightType === "O" ?
                <div style={{boxShadow: '0 1px 6px rgba(0, 0, 0, .22)', borderRadius: '6px', marginTop: '2.5rem'}}>
                  <StackedTupleMobile type="onward" />
                </div> : 
                <React.Fragment>
                  <div className={'mb-3 mt-3'} style={{boxShadow: '0 1px 6px rgba(0, 0, 0, .22)', borderRadius: '6px', marginTop: '2.5rem'}}>
                    <StackedTupleMobile tripType="roundTripOnward" type="onward" />
                  </div>
                  <div style={{boxShadow: '0 1px 6px rgba(0, 0, 0, .22)', borderRadius: '6px'}}>
                    <StackedTupleMobile tripType="roundTripReturn" type="return" />
                  </div>
                </React.Fragment>
              )
            }
          </Media>
        </div>
        <section className={`mb-3 phone-pl-2 phone-pr-2 phone-pt-0 phone-pb-0`}>
          <AddonsWrapper>
            <div className={`u-flex f-row align-items-center justify-content-between p-4 phone-f-column phone-align-items-start phone-mb-4`}>
              <div className={`phone-mb-4 u-flex f-column`}>
                <HeadingH2 size={16} weight="Medium" color="Dark">Contact Details</HeadingH2>
                <HeadingH3 size={13} weight="Regular" color="Normal">Ticket will be send on these details</HeadingH3>
              </div>
              <div className={`${classes.Divider} u-phoneHide`}></div>
              <DetailForm/>
            </div>
          </AddonsWrapper>          
        </section>
        <main className={classes.Main}>
          <div style={{display: (this.props.lob === "hotel" ? this.props.hotelPaxCounter : this.props.totalPaxConstant === 1 ? 1 : this.props.paxCounter) > 0 ? 'block' : 'none'}} className={classes.MainPrimary}>
              <div className="mb-4">
                <HeadingH2 size={16} weight="Medium" color="Dark">Add {paxType} Travellers ({paxCount})</HeadingH2>
                <HeadingH3 size={13} weight="Regular" color="Normal">Please ensure that the names of the passengers on the travel documents is the same as on their government issued identity proof.</HeadingH3>
              </div>
              <Pax lob={this.props.lob} paxType={paxType} />
              
          </div>
          {
            (this.props.totalPaxConstant !== 1 && passengers.length >= 1) ? 
            <Media query="(max-width: 500px)">
            {matches =>
              matches ? <AnimakitExpander
              expanded={this.props.passengers.length > 0}
              duration={400}
              align="top">
                {
                  this.props.passengers.length > 0  ? 
                  <div className={classes.MainSecondary}>
                    <div className={classes.ItemListContainer}>
                      <ul className={classes.ItemList}>
                        {passengerList}
                      </ul>
                    </div>
                  </div> : null
                }
            </AnimakitExpander> : 
              <div style={{borderTop: (this.props.lob === "hotel" ? this.props.hotelPaxCounter : this.props.paxCounter) > 0 ? `${border}` : 'none' }} className={classes.MainSecondary}>
                <div className={classes.ItemListContainer}>
                  <ul className={classes.ItemList}>
                    {passengerList}
                  </ul>
                </div>
              </div>  
            }
          </Media> : null
          }
        </main>
        </React.Fragment>
    );
  }
}

  const mapStateToProps = state => {
    return {
      travellerList: state.ui.travellerList,
      passengers: state.farePrice.passengers,
      guests: state.hotels.guests,
      flightType: state.farePrice.flightType,
      flowLogin: state.auth.flowLogin,
      userImages: state.ui.userImages,
      paxCounter: state.farePrice.paxCounter,
      hotelPaxCounter: state.hotels.paxCounter,
      adultCount: state.farePrice.adultCount,
      childCount: state.farePrice.childCount,
      infantCount: state.farePrice.infantCount,
      totalPaxConstant: state.farePrice.totalPaxConstant
    }
  }

const mapDispatchToProps = dispatch => {
  return {
    onResetSearch: () => dispatch(resetSearch()),
    onEditPax: (id) => dispatch(editPax(id)),
    onDeletePax: (id) => dispatch(deletePax(id)),
    onTogglePax: (id) => dispatch(togglePax(id)),
    onToggleHotelPax: (id) => dispatch(toggleHotelPax(id)),
    onCloseDropDown: () => dispatch(closeDropDown()),
    onUserImageUpload: (file, url, id) => dispatch(userImageUpload(file, url, id))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Passengers));



// WEBPACK FOOTER //
// ./src/containers/Passengers/Passengers.js